import React from "react";
import "./Paul_Thursby.css";



const Paul_Thursby = () => (

  <div className='Paul_Thursby'>

  <a href={"https://www.linkedin.com/in/paul-thursby/"} target={"_blank"}>
  <h3 className="text-center" >Paul Thursby</h3></a>
 
<p className='RecP'>Although Charles and I had different managers, 
and worked in different areas of the embedded systems with me at Echostar 
for nearly 4 years, Charles' efforts at the lower driver levels and 
debugging tool knowledge helped greatly to aid in discovering some 
of the more "trickier" bugs.</p>

<p className='RecP'>I do not recall all the specifics, but there 
was a time he and I had interaction troubleshooting a post-boot 
date acquisition matter. The product did not have an internal clock 
chip and relied upon getting the date/time via other methods, and 
there were issues at the lower level that Charles fixed. To the 
debugging knowledge, one big item that I recall is when several 
team members praised his back-tracing addition to our environment 
that was tremendously helpful troubleshooting many other problems 
that may have taken far more time to discover by other means.</p>

<p className='RecP'>Charles works well with others, so he would 
be a great addition to ANY new team. The software group at Echostar 
was roughly 60-70 people, all of various nationalities, experience 
levels, and knowledge areas.</p>

  </div>
);

export default Paul_Thursby;


// WEBPACK FOOTER //
// ./src/components/AboutMe/Paul_Thursby.js